<template>
  <div id="app">
    <div class="hero">
      <img src="./assets/main.jpeg" alt="" />
    </div>
    <a href="mailto:tottenhamhalemosque@gmail.com"
      >tottenhamhalemosque@gmail.com</a
    >
    <br />
    <strong
      >Friday 15th April - Jummua will be held in Unit 3B Mill Mead Industrial
      Estate Mill Mead Road N17 9QU in shaa Allah as the Engine Room is
      closed.</strong
    >
    <br />
    <img src="./assets/invite.jpg" alt="" />
  </div>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",
  components: {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.hero {
  height: 50%;

  /* Position and center the image to scale nicely on all screens */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
